import { ParsedSheet } from './UrlExcelMapper.types'

export interface UrlExcelMapperCache {
  sheets: ParsedSheet[]
  activeSheetName?: string
  selectedSheetNames: string[]
  rowsTruncated: boolean
  columnsTruncated: boolean
}

const EXCEL_MAPPER_CACHE_LIMIT = 2
export const excelMapperCache = new Map<string, UrlExcelMapperCache>()

export const setExcelMapperCache = (
  cacheKey: string,
  value: UrlExcelMapperCache
) => {
  excelMapperCache.delete(cacheKey)
  excelMapperCache.set(cacheKey, value)

  while (excelMapperCache.size > EXCEL_MAPPER_CACHE_LIMIT) {
    const oldestKey = excelMapperCache.keys().next().value
    if (oldestKey === undefined) break
    excelMapperCache.delete(oldestKey)
  }
}

export const clearUrlExcelMapperCache = (url?: string) => {
  const cacheKey = url?.trim()

  if (cacheKey) {
    excelMapperCache.delete(cacheKey)
    return
  }

  excelMapperCache.clear()
}
